export default __webpack_public_path__ + "static/avatar-tag-2-dont-dark-25723bd9744e399be3b930eed50526740b168a82b4fca8f633bf73de775dd2e6.png";